var map = {
	"./Sample": [
		2040,
		40
	],
	"./Sample/": [
		2040,
		40
	],
	"./Sample/index": [
		2040,
		40
	],
	"./Sample/index.js": [
		2040,
		40
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2855;
module.exports = webpackAsyncContext;